import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=e64f0d1c&scoped=true&"
import script from "./Portal.vue?vue&type=script&lang=ts&"
export * from "./Portal.vue?vue&type=script&lang=ts&"
import style0 from "./Portal.vue?vue&type=style&index=0&id=e64f0d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64f0d1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VApp,VCard})
